import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/nexus-utilities';
import { environment } from '../../../environments/environment';
import { ProductionCardBundle } from '../../models/production/production-card/production-card-bundle';

export interface ProductionCardBundleRollActionRequest {
  bundleReference: string;
  rollNumber: string;
}

@Injectable({
  providedIn: 'root',
})
export class ProductionCardBundleProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly _baseUrl = `${environment.proxyUrls.productionApi}/api/v1/production-card-bundle`;

  public getByProductionCardId(productionCardId: string): Observable<ApiResponse<ProductionCardBundle[]>> {
    return this.httpClient.get<ApiResponse<ProductionCardBundle[]>>(`${this._baseUrl}/production-card/${productionCardId}`);
  }

  public getByBundleId(bundleId: string): Observable<ApiResponse<ProductionCardBundle>> {
    return this.httpClient.get<ApiResponse<ProductionCardBundle>>(`${this._baseUrl}/${bundleId}`);
  }

  public getByBundleNumber(bundleNumber: string): Observable<ApiResponse<ProductionCardBundle>> {
    return this.httpClient.get<ApiResponse<ProductionCardBundle>>(`${this._baseUrl}/number/${encodeURIComponent(bundleNumber)}`);
  }

  public rollAction(request: ProductionCardBundleRollActionRequest): Observable<ApiResponse<ProductionCardBundle>> {
    return this.httpClient.post<ApiResponse<ProductionCardBundle>>(`${this._baseUrl}/roll-action`, request);
  }

  public createBundles(productionCardId: string): Observable<ApiResponse<ProductionCardBundle[]>> {
    return this.httpClient.post<ApiResponse<ProductionCardBundle[]>>(`${this._baseUrl}/create/${productionCardId}`, {});
  }

  public changeStatus(bundleId: string, newStatus: number): Observable<ApiResponse<ProductionCardBundle>> {
    return this.httpClient.patch<ApiResponse<ProductionCardBundle>>(`${this._baseUrl}/${bundleId}/status`, newStatus);
  }

  public weight(bundleId: string, weight: number): Observable<ApiResponse<ProductionCardBundle>> {
    return this.httpClient.post<ApiResponse<ProductionCardBundle>>(`${this._baseUrl}/${bundleId}/weight`, { weight });
  }

  public delete(bundleId: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this._baseUrl}/${bundleId}`);
  }

  public updateAssetId(bundleId: string, assetId: string | null): Observable<ApiResponse<ProductionCardBundle>> {
    return this.httpClient.patch<ApiResponse<ProductionCardBundle>>(`${this._baseUrl}/${bundleId}/asset`, { assetId });
  }
}
